import { convertLegacyDataProvider } from 'react-admin'

import uploadFileCapable from './uploadFileCapable'
import { restClient } from './provider'
import feathersClient from './feathersClient'
import { withChapterDiscussionDataProvider } from './resources/chapter-discussions/chapterDiscussions.dataProvider'

const restClientOptions = {
  id: 'id', // In this example, the database uses '_id' rather than 'id'
  usePatch: true, // Use PATCH instead of PUT for updates
}

export default () =>
  withChapterDiscussionDataProvider(
    convertLegacyDataProvider(
      uploadFileCapable(restClient(feathersClient.get(), restClientOptions)),
    ),
  )
